import { IconCaretLeft } from '@/components/icons/IconCaretLeft';
import { IconCaretRight } from '@/components/icons/IconCaretRight';
import { cn } from '@/lib/utils/tw-merge';
import type { UiSliderNavigationProps } from './UiSlider.types';

// The arrows are statically known, so they come from their own modules — the
// UiIcon registry would pull every icon of the site into this client bundle.
const BUTTON =
    'flex size-11 items-center justify-center rounded-full border border-(--border) bg-(--surface) text-(--text) transition-[color,border-color,opacity] duration-200 hover:border-(--accent) hover:text-(--accent) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--focus-ring) disabled:pointer-events-none disabled:opacity-40';

/** Prev/next controls. `.card-track-nav` shows them only where the track scrolls. */
export function UiSliderNavigation({
    canScrollPrev,
    canScrollNext,
    onPrev,
    onNext,
    className,
}: UiSliderNavigationProps) {
    return (
        <div className={cn('card-track-nav mt-2.5 justify-end gap-2.5', className)}>
            <button type="button" aria-label="Zurück" disabled={!canScrollPrev} onClick={onPrev} className={BUTTON}>
                <IconCaretLeft width={18} height={18} aria-hidden="true" />
            </button>

            <button type="button" aria-label="Weiter" disabled={!canScrollNext} onClick={onNext} className={BUTTON}>
                <IconCaretRight width={18} height={18} aria-hidden="true" />
            </button>
        </div>
    );
}
